<div class="modal solid open" id="NetworkControllerHARestartModal">
  <div (click)="close()" class="miniClose cancel icon-HamburgerAppClose"></div>
  <div class="title-row">
    <div class="icon" style="background-image: url(/assets/svgs/EditNetwork.svg)"></div>
    <div class="title-container">
      <div class="title">Restart Controllers</div>
      <div class="subtitle">Restart all controllers via host or process in parallel or via rolling restart mode. Restarting the host will not affect any Customer Hosted Controllers</div>
    </div>
  </div>

  <div class="content-row">
    <div id="RestartMode">
      <div class="label">
        Restart Scope
        <span class="specialnote">Required</span>
      </div>
      <app-filter-select
        [options]="scopeOptions"
        [(ngModel)]="selectedScopeOption"
        optionLabel="label">
        <ng-template let-selectedScopeOption appFilterSelectSelectedItem>
          <div class="dropdown-item">
            <span>{{ selectedScopeOption.label }}</span>
            @if (selectedScopeOption.tagValue) {
              <app-tag
                [severity]="selectedScopeOption.severity"
                [value]="selectedScopeOption.tagValue">
              </app-tag>
            }
          </div>
        </ng-template>
      </app-filter-select>
    </div>
  </div>
  <div class="content-row">
    <div id="RestartField">
      <div class="label">
        Restart Mode
        <span class="specialnote">Required</span>
      </div>
      <app-filter-select
        [options]="restartOptions"
        [(ngModel)]="selectedOption"
        optionLabel="label">
        <ng-template let-selectedOption appFilterSelectSelectedItem>
          <div class="dropdown-item">
            <span>{{ selectedOption.label }}</span>
            @if (selectedOption.tagValue) {
              <app-tag
                [severity]="selectedOption.severity"
                [value]="selectedOption.tagValue">
              </app-tag>
            }
          </div>
        </ng-template>
        <ng-template let-option appFilterSelectItem>
          <div class="dropdown-item">
            <span>{{ option.label }}</span>
            @if (option.tagValue) {
              <app-tag
                [severity]="option.severity"
                [value]="option.tagValue">
              </app-tag>
            }
          </div>
        </ng-template>
      </app-filter-select>
      @if (selectedOption.value === true) {
        <div>
          <app-message
            severity="warn"
            text="Restarting network controllers in parallel will cause network downtime and issues with connectivity during the restart process."
          ></app-message>
        </div>
      }
    </div>
  </div>
  <div class="button-row">
    <button (click)="restartAll()" class="save" id="CreateButton">Restart</button>
  </div>
</div>
